import React, { useState } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import logo from "../images/sud-ricambi-logo-color@0.5x.png";
import logoInvert from "../images/amotive-logo-symbol-color.png";
import logoInvert2 from "../images/TP-_logo-symbol-color.png";

function NavbarMobile() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      expand={false}
      expanded={expanded}
className="navbar-mobile m-3 rounded-pill shadow"
      style={{
        background: "#b9b9b9a1",
        padding: "14px 18px",
      }}
    >
      <Container fluid className="p-0 d-flex align-items-center">
        {/* LOGO */}
        <Navbar.Brand className="me-auto">
          <img src={logo} alt="Technoparts" style={{ maxWidth: "120px" }} />
        </Navbar.Brand>

        {/* SUD RICAMBI */}
        <Link to="/amotive" className="me-3">
          <img
            src={logoInvert}
            alt="Sud Ricambi"
            style={{ width: "28px" }}
          />
        </Link>

        {/* AMOTIVE */}
        <Link to="/technoparts" className="me-3">
          <img
            src={logoInvert2}
            alt="Amotive"
            style={{ width: "22px" }}
          />
        </Link>


       
      </Container>
    </Navbar>
  );
}

export default NavbarMobile;
